<ng-container [formGroup]="fg">
  <mat-form-field class="full-width">
    <mat-select placeholder="{{ showPlaceholder == true ? (placeholder | translate) : ''}}" [formControl]="control"
      matInput [required]="isRequired" [disabled]="isDisabled">
      <mat-option *ngFor=" let option of optionsList" [value]="option.value" [style.font-family]="option.text">
        {{ option.text }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-container>
